/**
 * @generated SignedSource<<adc18ef77c9eee3fed1d08a69f96cd43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SMTPConfigInput = {
  host: string;
  password: string;
  port: number;
  recipientAddress: string;
  senderAddress: string;
  username: string;
};
export type SettingsAlertsPageTestSmtpMutation$variables = {
  input: SMTPConfigInput;
};
export type SettingsAlertsPageTestSmtpMutation$data = {
  readonly testSmtpConfig: {
    readonly success: boolean;
  };
};
export type SettingsAlertsPageTestSmtpMutation = {
  response: SettingsAlertsPageTestSmtpMutation$data;
  variables: SettingsAlertsPageTestSmtpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAlertPreferencesPayload",
    "kind": "LinkedField",
    "name": "testSmtpConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsAlertsPageTestSmtpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsAlertsPageTestSmtpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3301192f90f132b46e0b7aba66c15028",
    "id": null,
    "metadata": {},
    "name": "SettingsAlertsPageTestSmtpMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsAlertsPageTestSmtpMutation(\n  $input: SMTPConfigInput!\n) {\n  testSmtpConfig(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0fe1e8e11f1b7dd5d3a6f059325b0458";

export default node;
